import { dispatch } from '../index'
import {
    FW_SET_FLOOR_WARDENS,
    FW_SET_FLOORS,
    FW_SET_IS_FLOOR_WARDEN,
    FW_TOGGLE_REGISTRATION,
    FW_SET_REGISTRATION_FLOOR,
    FW_SET_REGISTRATION_POSITION,
    FW_SET_REGISTRATION_ROLE,
    FW_SET_REGISTRATION_TYPE,
    FW_SET_ERROR_MESSAGE,
    FW_SET_PENDING_REQUEST,
    FW_SET_REGISTRATION_CONFIRMATION,
    FW_TOGGLE_DELETE_CONFIRM,
    FW_ADD_FLOOR_WARDEN_ENTRY,
    FW_REMOVE_FLOOR_WARDEN_ENTRY,
    FW_SET_ACKNOWLEDGED,
    FW_SET_FILTERED_FLOOR_WARDENS,
    FW_SET_FILTERED_REQUESTS,
    FW_SET_FLOOR_WARDEN_REQUESTS,
    FW_REMOVE_FLOOR_WARDEN_REQUEST
} from '../actionTypes'

export const setFloorWardens = (items) => {

    let floors = []
    if (items.length > 0) {
        floors = [...new Set(items.map((item) => item.floor))]
    } 

    dispatch({ floors: floors, type: FW_SET_FLOORS })
    dispatch({ floorWardens: items, type: FW_SET_FLOOR_WARDENS })
}

export const setIsFloorWarden = (isFloorWarden, acknowledged, position, version, message) => {
    dispatch({
        isFloorWarden: isFloorWarden,
        acknowledged,
        version,
        position,
        message,
        type: FW_SET_IS_FLOOR_WARDEN,
    })
    dispatch({ value: false, message: message, id: null, type: FW_SET_PENDING_REQUEST })
}

export const setIsAcknowledged = (acknowledged) => dispatch({ acknowledged, type: FW_SET_ACKNOWLEDGED })
export const setFilteredArray = (floorWardens) => dispatch({ floorWardens, type: FW_SET_FILTERED_FLOOR_WARDENS })
export const setFloors = (floors) => dispatch({ floors: floors, type: FW_SET_FLOORS })
export const toggleRegistration = () => dispatch({ type: FW_TOGGLE_REGISTRATION })
export const toggleDeleteConfirm = (data) => dispatch({ data: data, type: FW_TOGGLE_DELETE_CONFIRM })
export const setRegistrationFloor = (value) => dispatch({ floor: value, type: FW_SET_REGISTRATION_FLOOR })
export const setRegistrationPosition = (value) => dispatch({ position: value, type: FW_SET_REGISTRATION_POSITION })
export const setRegistrationRoles = (value) => dispatch({ role: value, type: FW_SET_REGISTRATION_ROLE })
export const setRegistrationType = (value) => dispatch({ regType: value, type: FW_SET_REGISTRATION_TYPE })
export const setErrorMessage = (msg) => dispatch({ text: msg, type: FW_SET_ERROR_MESSAGE })
export const setPendingRequest = (value, msg, id) => dispatch({ value: value, message: msg, id: id, type: FW_SET_PENDING_REQUEST })
export const setConfirmation = (value, msg) => dispatch({ value: value, text: msg, type: FW_SET_REGISTRATION_CONFIRMATION })
export const addFloorWarden = (floorWarden) => dispatch({ floorWarden, type: FW_ADD_FLOOR_WARDEN_ENTRY })
export const removeFloorWarden = (floorWarden) => dispatch({ floorWarden, type: FW_REMOVE_FLOOR_WARDEN_ENTRY })
export const setFilteredRequests = (requests) => dispatch({ requests, type: FW_SET_FILTERED_REQUESTS })

export const setFloorWardenRequests = requests => dispatch({requests, type: FW_SET_FLOOR_WARDEN_REQUESTS})
export const removeFloorWardenRequest = request => dispatch( {request, type: FW_REMOVE_FLOOR_WARDEN_REQUEST})